
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/internet",
      function () {
        return require("private-next-pages/shop/internet/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/internet"])
      });
    }
  